import { createStyles } from '@/contexts/theme-context';
import { shadow } from '@/styles';

export const useCarouselItemShadowStyles = createStyles((theme) => ({
  shadow: {
    backgroundColor: theme.colors.white,
    ...shadow({
      color: theme.colors.black,
      elevation: 2,
      opacity: 0.1,
      radius: 4,
      x: 0,
      y: 0,
    }),
  },
}));
